<template>
  <div class="select">
    <cc-table
      :headerButton="headerButton"
      :loadData="false"
      :dataArr="dataArr"
      :config="table"
      :params="params"
      :refeshParams="refeshTable"
      :emptyText="language('productDetails.emptyText')"
      :showIndex="false"
      :buttonsWidth="100"
    ></cc-table>

    <el-dialog
      :close-on-click-modal="false"
      title="Content"
      :visible.sync="addDialog"
      width="90%"
      append-to-body
    >
      <template v-if="addDialog">
        <cc-search
          :config="searchConfig"
          @doSearch="doSearch"
          size="medium"
        ></cc-search>
        <cc-table
          :loadData="true"
          :config="contentTable"
          :params="contentParams"
          :refeshParams="contentRefeshTable"
          @submit-select="submitSelect"
          :emptyText="language('shopCategory.emptyText')"
        ></cc-table>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: "Array",
    event: "click",
  },
  props: {
    formData: {
      type: Object,
    },
  },
  data() {
    return {
      dataArr: [],
      headerButton: [
        {
          btnName: "Add Product(s)",
          onClick: () => {
            this.addDialog = true;
            this.contentParams = {
              mchShopNum: this.$shopData.shopNum,
              shopNum: this.$shopData.shopNum,
              type: this.formData.type,
            };
          },
        },
      ],
      table: {
        api: "",
        showPager: false,
        columns: [
          {
            prop: "mchProduct.saleStatus",
            lable: "Displayed",
            type: "tag",
            minWidth: 110,
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
              // 1: {
              //   tagType: "danger",
              //   text: "不支持线上销售",
              // },
              // 2: {
              //   tagType: "danger",
              //   text: "待上架",
              // },
            },
          },
          {
            prop: "mchProduct.status",
            lable: "Status",
            type: "tag",
            minWidth: 120,
            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "mchProduct.type",
            lable: "Type",
            type: "tag",
            minWidth: 215,
            options: {
              H: {
                tagType: "success",
                text: "Non Book",
              },
              C: {
                tagType: "success",
                text: "(Book) Mainland/國版",
              },
              D: {
                tagType: "success",
                text: "(Book) HKG/港版",
              },
              E: {
                tagType: "success",
                text: "(Book) TWN/台版",
              },
              F: {
                tagType: "success",
                text: "(Book) Others/外文版",
              },
              A: {
                tagType: "success",
                text: "(Book)SUP/本版",
              },
              'DT000': {
                tagType: "success",
                text: "PRY.HK/小學教參",
              },
              "DT100": {
                tagType: "success",
                text: "SEC.HK/中學教參",
              },
              "DT200": {
                tagType: "success",
                text: "UNI.HK/大專教參",
              },
              'FT000': {
                tagType: "success",
                text: "PRY.F/外文小學教參",
              },
              "FT100": {
                tagType: "success",
                text: "SEC.F/外文中學教參",
              },
              'FT200': {
                tagType: "success",
                text: "UNI.F/外文大專教參",
              },
            },
          },
          {
            prop: "mchProduct.mchProductId",
            lable: "Model ID",
            minWidth: 150,
          },

          // {
          //   prop: "barcode",
          //   lable: "SKU ID（Barcode）",
          //   minWidth: 150,
          // },
          // {
          //   prop: "productNum",
          //   lable: "Article Master",
          //   minWidth: 150,
          // },
          {
            prop: "mchProduct.name",
            lable: "Product Name（Chi.）",
            minWidth: 180,
          },
          //   {
          //     prop: "cover",
          //     lable: "Product Cover",
          //     minWidth: 80,
          //     type: "img",
          //     urlPropName: "cover",
          //     sourceUrlPropName: "cover",
          //     // imgCompressParams: "?x-oss-process=image/resize,w_600",
          //     w: 40,
          //     h: 40,
          //   },
          {
            prop: "mchProduct.categories",
            lable: "Category（System）",
            minWidth: 120,
          },
          {
            prop: "mchProduct.brand",
            minWidth: 120,
            lable: "Brand",
          },
          {
            prop: "mchProduct.salePrice",
            lable: "Selling Price(HKD)",
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.mchProduct.salePrice * 1, 2);
            },
            minWidth: 100,
          },
          //   {
          //     prop: "updateAdminName",
          //     lable: "Update By",
          //     minWidth: 100,
          //   },
          //   {
          //     prop: "updateTime",
          //     lable: "Last Update",
          //     minWidth: 200,
          //   },
          //   {
          //     prop: "createTime",
          //     lable: "Create Date",
          //     minWidth: 200,
          //   },
        ],
        buttons: [
          {
            name: this.language("setDetails.delete"),
            click: (row, index) => {
              this.delete(index);
            },
          },
        ],
      },
      params: {},
      refeshTable: -1,
      addDialog: false,
      searchConfig: [
             {
          title: "Model ID",
          fieldName: "mchProductId",
          style: "text",
          displayName: "",
        },
        {
          title: "SKU ID / Barcode",
          fieldName: "barcode",
          style: "text",
          displayName: "",
        },
        {
          title: "Product Name",
          fieldName: "name",
          style: "text",
          displayName: "",
        },
      ],
      contentTable: {
        api: "admin/merchant/product/query?status=1&isDiscount=0",
        showPager: true,
        selection: true,
        selectType: "Object",
        selectingResult: true,
        selectionLabel: this.language("shopCategory.addProduct"),
        indexFixed: "left",
        columns: [
          {
            minWidth: 110,
            prop: "saleStatus",
            lable: "Displayed",
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
              // 1: {
              //   tagType: "danger",
              //   text: "不支持线上销售",
              // },
              // 2: {
              //   tagType: "danger",
              //   text: "待上架",
              // },
            },
          },
          {
            minWidth: 120,
            prop: "auditStatus",
            lable: "Status",
            type: "tag",
            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "type",
            lable: "type",
            type: "tag",
            minWidth: 190,
            options: {
              H: {
                tagType: "success",
                text: "Non Book",
              },
              C: {
                tagType: "success",
                text: "(Book) Mainland/國版",
              },
              D: {
                tagType: "success",
                text: "(Book) HKG/港版",
              },
              E: {
                tagType: "success",
                text: "(Book) TWN/台版",
              },
              F: {
                tagType: "success",
                text: "(Book) Others/外文版",
              },
              A: {
                tagType: "success",
                text: "(Book)SUP/本版",
              },
              'DT000': {
                tagType: "success",
                text: "PRY.HK/小學教參",
              },
              "DT100": {
                tagType: "success",
                text: "SEC.HK/中學教參",
              },
              "DT200": {
                tagType: "success",
                text: "UNI.HK/大專教參",
              },
              'FT000': {
                tagType: "success",
                text: "PRY.F/外文小學教參",
              },
              "FT100": {
                tagType: "success",
                text: "SEC.F/外文中學教參",
              },
              'FT200': {
                tagType: "success",
                text: "UNI.F/外文大專教參",
              },
            },
          },
             {
            prop: "mchProductId",
            lable: "Model ID",
            minWidth: 200,
          },
          {
            prop: "barcode",
            lable: "SKU ID（Barcode）",
            minWidth: 200,
          },
          {
            prop: "name",
            lable: "Product Name（Chi.）",
            minWidth: 180,
          },
          {
            prop: "categories",
            lable: "Category（System）",
            minWidth: 120,
          },
          {
            prop: "brand",
            lable: "Brand",
            minWidth: 120,
          },
          {
            prop: "listPrice",
            lable: "OriginalPrice",
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.listPrice, 2);
            },
            minWidth: 100,
          },
          {
            prop: "updateAdminName",
            lable: "Update By",
            minWidth: 100,
          },
          {
            prop: "updateTime",
            lable: "Last Update",
            minWidth: 200,
          },
          {
            prop: "createTime",
            lable: "Create Date",
            minWidth: 200,
          },
        ],
        buttons: [],
      },
      contentParams: {
        mchShopNum: this.$shopData.shopNum,
        shopNum: this.$shopData.shopNum,
      },
      contentRefeshTable: {},
    };
  },
  watch: {
    formData: {
      handler() {
        this.dataArr = [...this.formData.mchProductPackageItems];
        console.log(this.formData, "this.formData");
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    doSearch(e) {
      this.contentParams = {
        ...e,
        mchShopNum: this.$shopData.shopNum,
        shopNum: this.$shopData.shopNum,
        type: this.formData.type,
      };
    },
    submitSelect(e) {
      console.log(e);
      let eArry = [];
      for (let index = 0; index < e.length; index++) {
        eArry.push({
          mchProduct: e[index],
        });
      }
      let arr = [...this.dataArr, ...eArry];
      let res = [];
      let obj = {};
      for (let i = 0; i < arr.length; i++) {
        if (!obj[arr[i].mchProduct.id]) {
          let objData = {
            mchProduct: {
              saleStatus: arr[i].mchProduct.saleStatus,
              status: arr[i].mchProduct.status,
              type: arr[i].mchProduct.type,
              mchProductId: arr[i].mchProduct.mchProductId,
              name: arr[i].mchProduct.name,
              categories: arr[i].mchProduct.categories,
              brand: arr[i].mchProduct.brand,
              salePrice: arr[i].mchProduct.salePrice,
              shopNum: this.$shopData.shopNum,
              mchShopNum: this.$shopData.mchShopNum,
              id: arr[i].mchProduct.id,
              mb1ProductId: arr[i].mchProduct.mb1ProductId,
            },

            itemMchModleId: arr[i].mchProduct.mchProductId,
            itemMchProductId: arr[i].mchProduct.id,
            nrProductId: arr[i].mchProduct.mb1ProductId,
          };
          if (this.formData && this.formData.id) {
            objData.mchProductId = this.formData.id;
          }
          res.push(objData);
          obj[arr[i].mchProduct.id] = true;
        }
      }
      this.dataArr = res;
      this.addDialog = false;
      console.log(res, "res");
      this.$emit("click", this.dataArr);
      this.$bus.$emit("changeTotalPrice", this.dataArr);
    },
    delete(index) {
      this.dataArr.splice(index, 1);
      this.$emit("click", this.dataArr);
      this.$bus.$emit("changeTotalPrice", this.dataArr);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.select {
  width: 100%;
}
</style>
